import {
	AuditOutlined,
	ContainerOutlined,
	DashboardOutlined,
	FieldTimeOutlined,
	FileProtectOutlined,
	FileTextOutlined,
	HomeOutlined,
	ShoppingOutlined,
	TableOutlined,
	TeamOutlined,
} from "@ant-design/icons";

export const ItemSupperAdmin = [
	{
		label: "Quản trị tài khoản",
		key: "/admin/listAccount",
		icon: <TeamOutlined />,
	},
	{
		label: "Quản trị bếp ăn",
		key: "/admin/listKitchen",
		icon: <HomeOutlined />,
	},
	{
		label: "Quản trị quyền tài khoản",
		key: "/admin/listRoles",
		icon: <AuditOutlined />,
	},
	{
		label: "Cấu hình thời gian đặt cơm",
		key: "/admin/listOderTime",
		icon: <DashboardOutlined />,
	},
	{
		label: "Quản trị thực đơn",
		icon: <ShoppingOutlined />,
		key: "/Menus",
		children: [
			{ label: "Suất thường", key: "/admin/listMenu" },
			{ label: "Suất đặc biệt", key: "/admin/listMenuSpecial" },
		],
	},
	{
		label: "Quản trị câu hỏi khảo sát",
		key: "/admin/listQuestion",
		icon: <FileProtectOutlined />,
	},
	{
		label: "Báo cáo",
		key: "/Services",
		icon: <FileTextOutlined className="hover:text-white" />,
		children: [
			{ label: "Báo cáo suất ăn", key: "/admin/MealReportPage" },
			{ label: "Báo cáo câu hỏi khảo sát", key: "/admin/ReportQuestionPage" },
			{ label: "Báo cáo đánh giá", key: "/admin/SurveryReportPage" },
		],
	},
	{
		label: "Tra cứu log",
		key: "/logging",
		icon: <ContainerOutlined className="hover:text-white" />,
		children: [
			{ label: "Log thanh toán", key: "/admin/paymentLog" },
			{ label: "Log thao tác CBNV", key: "/admin/orderLog" },
		],
	},
	// {
	// 	label: "Tạo mã QR",
	// 	key: "/admin/create-qrcode",
	// 	icon: <ContainerOutlined />,
	// },
];

export const ItemAdmin = [
	{
		label: "Quản trị bếp ăn",
		key: "/admin/listKitchen",
		icon: <HomeOutlined />,
	},
	// {
	//   label: "Cấu hình thời gian đặt cơm",
	//   key: "/admin/listOderTime",
	//   icon: <DashboardOutlined />,
	// },
	// {
	//   label: "Quản trị thực đơn",
	//   key: "/admin/listMenu",
	//   icon: <ShoppingOutlined />,
	// },
	// {
	//   label: "Quản trị bếp ăn",
	//   key: "/admin/listKitchen",
	//   icon: <HomeOutlined />,
	// },
	{
		label: "Quản trị thực đơn",
		icon: <ShoppingOutlined />,
		key: "/Menus",
		children: [
			{ label: "Suất thường", key: "/admin/listMenu" },
			{ label: "Suất đặc biệt", key: "/admin/listMenuSpecial" },
		],
	},
	{
		label: "Quản trị câu hỏi khảo sát",
		key: "/admin/listQuestion",
		icon: <FileProtectOutlined />,
	},
	{
		label: "Báo cáo",
		key: "/Services",
		icon: <TableOutlined className="hover:text-white" />,
		children: [
			{ label: "Báo cáo suất ăn", key: "/admin/MealReportPage" },
			{ label: "Báo cáo câu hỏi khảo", key: "/admin/ReportQuestionPage" },
			{ label: "Đánh giá", key: "/admin/SurveryReportPage" },
		],
	},
	// {
	// 	label: "Tạo mã QR",
	// 	key: "/admin/create-qrcode",
	// 	icon: <ContainerOutlined />,
	// },
];

export const ItemUser = [
	// {
	//   label: "Cấu hình thời gian đặt cơm",
	//   key: "/admin/listOderTime",
	//   icon: <DashboardOutlined />,
	// },
	// {
	//   label: "Quản trị thực đơn",
	//   key: "/admin/listMenu",
	//   icon: <ShoppingOutlined />,
	// },
	// {
	//   label: "Quản trị bếp ăn",
	//   key: "/admin/listKitchen",
	//   icon: <HomeOutlined />,
	// },
	{
		label: "Quản trị thực đơn",
		icon: <ShoppingOutlined />,
		key: "/Menus",
		children: [
			{ label: "Suất thường", key: "/admin/listMenu" },
			{ label: "Suất đặc biệt", key: "/admin/listMenuSpecial" },
		],
	},
	{
		label: "Quản trị câu hỏi khảo sát",
		key: "/admin/listQuestion",
		icon: <FileProtectOutlined />,
	},
	{
		label: "Báo cáo",
		key: "/Services",
		icon: <TableOutlined className="hover:text-white" />,
		children: [
			{ label: "Báo cáo suất ăn", key: "/admin/MealReportPage" },
			{ label: "Báo cáo câu hỏi khảo", key: "/admin/ReportQuestionPage" },
			{ label: "Đánh giá", key: "/admin/SurveryReportPage" },
		],
	},
	// {
	// 	label: "Tạo mã QR",
	// 	key: "/admin/create-qrcode",
	// 	icon: <ContainerOutlined />,
	// },
];
